import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import { Field, reduxForm } from 'redux-form'
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import Footer from "../../Footer/FooterBottom";
import api from '../../../api/api';
import history from '../../../history';
import { checkLogin } from '../../actions/';
import TopOfMountain from "../../Admin/Question/View/Background/TopOfMountain";

class RecognizedBrowser extends React.Component {

    state = { showGetCode: true, waitTime: 150, sendCount: 1, currentStatus: "" };

    constructor(props) {
        super(props);
        this._toastId = new React.createRef();
        history.push("/RecognizedBrowser");
        this.yourTime = 0;
    }

    componentDidMount() {
        setInterval(() => {
            this.yourTime += 1;
            if (this.yourTime === this.state.waitTime) {
                this.setState({
                    showGetCode: true
                });
            }
        }, 1000);
        window.scrollToPosition("main-recognized-browser-section");
    }

    getCode = () => {

        const { t } = this.props;

        this._toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(this._toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        api.get(`/GetCode/`).then(response => {

            toast.update(this._toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-info"></i> {t('Pages.ActivePage.GetCode_success_toast.Title')}</div> <div className="h6">{t('Pages.ActivePage.GetCode_success_toast.Body')}</div></div>,
                type: toast.TYPE.INFO,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            this.yourTime = 0;
            let sendCount = this.state.sendCount + 1;
            this.setState({
                showGetCode: false,
                sendCount,
                waitTime: this.state.waitTime * sendCount
            });

            this.setState({
                currentStatus: "True"
            });

        }).catch(error => {
            toast.update(this._toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            this.setState({
                currentStatus: "Wrong"
            });
        });
    }

    renderField = ({
        input,
        title,
        type,
        placeholder,
        required,
        className,
        style,
        meta: { touched, error }
    }) => (
        <>
            <input {...input} title={title} placeholder={placeholder} style={style} required={required} type={type} autoComplete="off" spellCheck={false} className={`${className} ${(touched && error) ? 'is-invalid' : ''}`} />
            {touched && error && <div className="invalid-feedback">{this.props.t(error)}</div>}
        </>
    );

    validate = () => {
        const errors = {};

        if (!this.RecognizedBrowser.ref.current.getValue()) {
            errors.RecognizedBrowser = 'Pages.RecognizedBrowser.input.error';
        }

        return errors;
    }

    onSubmit = e => {
        const { t } = this.props;

        this._toastId.current = toast(t('Processing'), {
            position: "bottom-left",
            autoClose: false
        });
        toast.update(this._toastId.current, {
            render: () => <div> <i className="fa-spin fas fa-spinner "></i> {t('Processing')} </div>,
            autoClose: false,
            closeOnClick: false,
        });

        var errors = this.validate();
        if (errors && errors.length !== 0 && Object.keys(errors).length !== 0) {
            toast.update(this._toastId.current, {
                render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.RecognizedBrowser.error_AllInformationIsRequired_toast.Title')}</div> <div className="h6">{t('Pages.RecognizedBrowser.error_AllInformationIsRequired_toast.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            this.setState({
                currentStatus: "Wrong"
            });
        } else {

            api.post(`/GetCode/`, {
                Code: this.RecognizedBrowser.ref.current.getValue()
            }).then(response => {
                if (response.data.code !== "success") {
                    toast.update(this._toastId.current, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-bug"></i> {t('Pages.RecognizedBrowser.error_info_toast.Title')}</div> <div className="h6">{t('Pages.RecognizedBrowser.error_info_toast.Body')}</div></div>,
                        type: toast.TYPE.ERROR,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    this.setState({
                        currentStatus: "Wrong"
                    });
                } else {


                    this.setState({
                        currentStatus: "True"
                    }, () => {
                        setTimeout(() => {
                            const browserToken = response.data.data.browserToken;
                            localStorage.setItem('browserToken', browserToken);
                            this.props.checkLogin();
                            history.push("/User/Control");
                        }, 1000);
                    });
                    toast.update(this._toastId.current, {
                        render: () => <div><div className="h5"> <i className="icon fal fa-shield-check"></i> {t('Pages.RecognizedBrowser.success_toast.Title')}</div> <div className="h6">{t('Pages.RecognizedBrowser.success_toast.Body')}</div></div>,
                        type: toast.TYPE.SUCCESS,
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: false,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

                }
            }).catch(error => {
                toast.update(this._toastId.current, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-wifi-slash"></i> {t('Error.NoConnection.Title')}</div> <div className="h6">{t('Error.NoConnection.Body')}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                this.setState({
                    currentStatus: "Wrong"
                });
            });
        }
        e.preventDefault();
    }

    FinishMove = () => {
        this.setState({
            currentStatus: ""
        });
    }

    render() {
        const { t, user } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.RecognizedBrowser.title')} | {t('alarabeyya')}
                    </title>
                </Helmet>
                <style dangerouslySetInnerHTML={{ __html: `html{width: calc(100% );overflow-x: unset;}header{ display:none; }body{overflow-x: hidden;}section{padding-top:5px !important;}.footer-bottom{display:none;}` }}></style>
                <section className="pos-rel  call-overlay call-in-action oh" id="main-recognized-browser-section" style={{
                    backgroundColor: '#75cdff',
                    borderBottom: '1px solid #0e2c53',
                    minHeight: '100vh'
                }}>

                    <TopOfMountain currentStatus={this.state.currentStatus} FinishMove={this.FinishMove} />

                    <div className="container padding-top padding-bottom" style={{
                        minHeight: '100vh'
                    }}>

                        <div className="account-wrapper p-3 pt-5">
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className="section-header mb-0">
                                        <span className="cate">{t('Pages.RecognizedBrowser.title')}</span>
                                        <h4 className="title">{t('Pages.RecognizedBrowser.subTitle')}</h4>
                                    </div>
                                </div>
                            </div>
                            <form method="POST" className="contact-form px-2 pb-5 pt-4" onSubmit={this.onSubmit} autoComplete="new-password">

                                <div className={`contact-form p-3 w-100 mb-2 inner-box p-1 pt-4  `} style={{
                                    background: 'rgb(170 233 255)',
                                    border: '1px solid rgb(0 191 255)',
                                    borderRadius: '10px'
                                }}  >
                                    <div>
                                        <div className="title h2 mb-0">
                                            <i className="icon fal fa-info"></i>
                                        </div>
                                        <p className="text-justify">
                                            {t('Pages.ActivePage.info')}
                                        </p>

                                        <div className="list py-0 w-100 text-right">
                                            <ul>
                                                تم ارسال المعلومات الى:
                                                <li>
                                                    <i className="fas mx-1 fa-mail-bulk"  ></i>
                                                    {user.user?.Email}.
                                                </li>
                                                <li>
                                                    <i className="fas mx-1 fa-phone"  ></i>
                                                    {user.user?.Phone}.
                                                </li>
                                            </ul>

                                        </div>
                                        <div className="mt-3 text-justify">
                                            في حال كان هناك مشكلة في البريد الإلكترونيّ المدخل يرجى الضغط على
                                            <Link to="/Logout" className="mx-1 cursor-pointer">
                                                إعادة عملية التسجيل مرة اخرى
                                            </Link>
                                            أو قم
                                            <Link to="/Contact" className="mx-1 cursor-pointer">
                                                بالاتصال بنا
                                            </Link> .
                                        </div>
                                    </div>
                                </div>

                                {
                                    this.state.showGetCode ?
                                        <div className={`contact-form p-3 w-100 mb-2 inner-box p-3 justify-content-center  `} style={{
                                            background: 'rgb(255 170 170)',
                                            border: '1px solid rgb(235 92 92)',
                                            borderRadius: '10px'
                                        }}  >
                                            <div>
                                                <p className="text-center">
                                                    {t('Pages.ActivePage.notGetTheCode')}
                                                    <div onClick={() => this.getCode()} className="mx-1 font-weight-bold cursor-pointer">
                                                        {t('Pages.ActivePage.GetCode')}
                                                    </div>
                                                </p>
                                            </div>
                                        </div>
                                        : ""
                                }

                                <div className="form-group w-100 mb-2">
                                    <Field
                                        ref={RecognizedBrowser => this.RecognizedBrowser = RecognizedBrowser}
                                        name="RecognizedBrowser"
                                        component={this.renderField}
                                        type="text"
                                        required={true}
                                        className="form-control"
                                        placeholder={t('Pages.RecognizedBrowser.input.Placeholder')}
                                        title={t('Pages.RecognizedBrowser.input.title')}
                                    />
                                </div>
                                <div className="form-group w-100">
                                    <button className="custom-button mt-1 w-100"><span> {t('Pages.RecognizedBrowser.Active')}</span></button>
                                </div>
                            </form>
                        </div>

                    </div>
                </section>
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

const validate = values => {
    const errors = {};

    if (!values.RecognizedBrowser) {
        errors.RecognizedBrowser = 'Pages.RecognizedBrowser.input.error';
    }
    return errors;
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

const formRecognizedBrowser = reduxForm({
    form: 'RecognizedBrowser',
    validate
});

export default connect(mapStateToProps, { checkLogin })(withTranslation('common')(formRecognizedBrowser(RecognizedBrowser)));